export const styles = {
  stepper: {
    marginTop: '20px',
    '& .MuiStep-root': {
      padding: '0',
    },
    '& .MuiStepLabel-iconContainer': {
      paddingRight: '14px',
    },
    '& .MuiStepConnector-root': {
      maxWidth: '24px',
      margin: '0 12px',
    },
    '& .Mui-completed': {
      color: '#6E707A',
    },
    '& .Mui-active': {
      '& path, & rect': {
        stroke: '#4D6EF5',
      },
    },
  },

  stepStyles: {
    cursor: 'pointer',
    '& path, & rect': {
      stroke: 'white !important',
    },
    '& span': {
      cursor: 'pointer !important',
    },
  },

  dialogContent: {
    height: 'calc(100% - 166px)',
    padding: '20px 0px',
  },

  selectionsContainer: {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
  },

  mainContent: {
    width: '100%',
  },
};
